module.exports = __webpack_public_path__ + "static/media/exo.728aaeeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/exo.svg
// module id = 784
// module chunks = 0